/* V5: match Loganberry's visible can height to the standard square cutouts.
 * Measured opaque artwork bounds: reference 841/1080; Loganberry 1144/1296.
 * Source matching deliberately excludes lifestyle and composite photographs.
 */
(() => {
  const selector = 'img[src*="dc1091_9408a2fbc78a438b849fcc3700db2c8d_mv2"]';
  const referenceCoverage = 841 / 1080;
  const sourceCoverage = 1144 / 1296;
  const sourceAspect = 872 / 1296;
  const observed = new Set();

  function fit(image, width, height) {
    if (width <= 0 || height <= 0) return;
    const squareHeight = Math.min(width, height);
    const portraitHeight = Math.min(width / sourceAspect, height);
    const scale = (squareHeight * referenceCoverage / (portraitHeight * sourceCoverage)).toFixed(5);
    if (image.style.getPropertyValue('--cc-logan-scale') !== scale) {
      image.style.setProperty('--cc-logan-scale', scale);
    }
  }

  const resize = new ResizeObserver(entries => {
    for (const {target, contentRect} of entries) fit(target, contentRect.width, contentRect.height);
  });

  function track(image) {
    if (image.matches(selector)) {
      if (!observed.has(image)) {
        observed.add(image);
        resize.observe(image);
      }
      fit(image, image.clientWidth, image.clientHeight);
    } else if (observed.delete(image)) {
      resize.unobserve(image);
      image.style.removeProperty('--cc-logan-scale');
    }
  }

  function scan(root) {
    if (root instanceof HTMLImageElement) track(root);
    root.querySelectorAll?.(selector).forEach(track);
  }

  scan(document);
  new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'attributes') track(record.target);
      else record.addedNodes.forEach(scan);
    }
    for (const image of observed) {
      if (!image.isConnected) {
        resize.unobserve(image);
        observed.delete(image);
      }
    }
  }).observe(document.documentElement, {subtree: true, childList: true, attributes: true, attributeFilter: ['src', 'srcset']});
})();
